import type { JSX } from 'react';
import { Skeleton } from '@/components/ui/skeleton.js';

/**
 * Squelette d'un `PageHeader` de fiche (commande, facture) : lien de retour,
 * titre + statut, ligne de métadonnées, actions à droite.
 */
export function DetailHeaderSkeleton(): JSX.Element {
  return (
    <div className="flex flex-col gap-3">
      <Skeleton className="h-4 w-36" />
      <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-3">
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-5 w-20" />
          </div>
          <Skeleton className="h-4 w-72 max-w-full" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-9 w-40" />
          <Skeleton className="h-9 w-32" />
        </div>
      </div>
    </div>
  );
}

/** Squelette d'un panneau de fiche (`PageSection`) : titre puis quelques lignes. */
export function DetailPanelSkeleton({ lines = 3 }: { lines?: number }): JSX.Element {
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-border bg-card p-5">
      <Skeleton className="h-4 w-32" />
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton
          key={`line-${String(index)}`}
          className={index % 2 === 0 ? 'h-3.5 w-full max-w-md' : 'h-3.5 w-2/3 max-w-xs'}
        />
      ))}
    </div>
  );
}
